// cache: 'reload' bypasses the entry Chrome stored from the thumbnail's
// no-cors <img> load, which would otherwise be replayed without CORS headers.
export const fetchImageBlob = async (url: string): Promise<Blob> => {
  const response = await fetch(url, { mode: 'cors', cache: 'reload' });
  if (!response.ok) {
    throw new Error(`Error fetching image: ${response.statusText}`);
  }
  return response.blob();
};
